fccd-facet-checkbox-list {
  width: 100%;
  hp5-filter-panel div.content {
    padding: 0 !important;
  }
}
